import React from "react";
import { Dialog } from "primereact/dialog";
import axios from "axios";
import "./ImportarExcelModal.css"
import AsyncSelect from "react-select/async";
import { asyncSelectCustomStyles } from "../../util/styles";
import { reactSelectIcons } from "../../util/reactSelectPrimeIcons";

class ImportarExcelModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            file: null,
            loading: false,
            property_of_interest: ""
        };

        this.fileInputRef = React.createRef();
    }

    triggerFileSelect = () => {
        if (this.fileInputRef.current) {
            this.fileInputRef.current.click();
        }
    }

    handleImport = async () => {
        if (!this.state.file) {
            return alert("Insira um arquivo xlsx!");
        }
        if (!this.state.property_of_interest) {
            return alert("Selecione um empreendimento!");
        }

        this.setState({ loading: true });
        this.props.onLoadingChange?.(true);
        let formData = new FormData();
        formData.append("file", this.state.file);
        formData.append("property_of_interest", this.state.property_of_interest.value);

        try {
            const response = await axios.post("/geo-referenciamento/import", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response.data.status === "Success") {
                this.setState({ file: null });
                this.props.toast?.();
                this.props.onHide?.();
                this.props.onImportSuccess?.(
                    response.data.imported_properties,
                    response.data.unregistered_properties
                );
            }
        } catch (error) {
            console.error("Erro no upload", error);
            const message = error.response?.data?.message || "Erro ao importar arquivo.";
            alert(message);
        }
        finally {
            this.setState({ loading: false });
            this.props.onLoadingChange?.(false);
        }
    };

    renderFooter() {
        const { file } = this.state;

        return (
            <div className="importar-footer">
                {!this.state.loading && <>
                    <button
                        type="button"
                        className="btn btn-default bold importar-btn-select"
                        onClick={this.triggerFileSelect}
                    >
                        {file ? file.name : 'SELECIONAR'}
                    </button>

                    <button
                        type="button"
                        className="btn importar-btn-import bold"
                        onClick={this.handleImport}
                        disabled={this.state.loading}
                    >
                        IMPORTAR
                    </button>
                </>}
                {this.state.loading && (
                    <img alt="carregando..." src="/img/loader.gif" style={{ height: '34px' }} />
                )}
            </div>
        );
    }

    render() {
        return (
            <Dialog
                header="Importar"
                visible={this.props.show}
                modal
                closable
                onHide={this.props.onHide}
                footer={this.renderFooter()}
                className="importar-dialog"
            >
                <p className="importar-warning">
                    Fazer uma importação irá sobrescrever os dados anteriores.<br />
                    Caso deseje, salve seu projeto atual antes de continuar.
                </p>

                <div className="importar-field">
                    <label>Empreendimento</label>
                    <AsyncSelect
                        styles={{
                            ...asyncSelectCustomStyles,
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        components={reactSelectIcons}
                        placeholder="Digite"
                        isMulti={false}
                        closeMenuOnSelect={true}
                        defaultOptions={this.props.buscaEmpreendimentossDefaultOptions}
                        loadOptions={this.props.searchBuildings}
                        onMenuClose={this.props.clearDefaultEmpreendimentos}
                        onChange={(value) => this.setState({ property_of_interest: value })}
                        loadingMessage={() => 'Carregando...'}
                        noOptionsMessage={() => "Digite para buscar..."}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                    />

                    <input
                        ref={this.fileInputRef}
                        id="file-upload-input"
                        type="file"
                        accept=".xlsx, .xls"
                        style={{ display: 'none' }}
                        onChange={(e) => {
                            if (e.target.files && e.target.files[0]) {
                                this.setState({ file: e.target.files[0] });
                            }
                        }}
                    />
                </div>
            </Dialog>
        );
    }
}

export default ImportarExcelModal;
